
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M7.499.117a7.383 7.383 0 10.003 14.767A7.383 7.383 0 007.499.117zm0 1.044a6.347 6.347 0 016.34 6.339H1.161a6.346 6.346 0 016.338-6.339z"}})])
          )
        }
      }
    